import { atom } from 'jotai'

/** Used only for the embed product list filters */
export const currentEmbedFiltersAtom = atom<string | undefined>(undefined)
